import {
  Card as MuiCard,
  CardActions as MuiCardActions,
  CardContent as MuiCardContent,
  CardHeader as MuiCardHeader,
  type CardActionsProps as MuiCardActionsProps,
  type CardContentProps as MuiCardContentProps,
  type CardHeaderProps as MuiCardHeaderProps,
  type CardProps as MuiCardProps,
} from '@mui/material'

export type CardProps = MuiCardProps
export type CardHeaderProps = MuiCardHeaderProps
export type CardContentProps = MuiCardContentProps
export type CardActionsProps = MuiCardActionsProps

export const Card = MuiCard
export const CardHeader = MuiCardHeader
export const CardContent = MuiCardContent
export const CardActions = MuiCardActions
